import { resolvePaymentSubscriptionLocalStorage } from '~/helpers/payments'

export default function ({ store }) {
  store.app.router.afterEach((to, from, next) => {
    resolvePaymentSubscriptionLocalStorage(store)
  })
}
